export default {"src":"/_next/static/media/Korea.0bc7531f.svg","height":401,"width":320,"blurWidth":0,"blurHeight":0};